<div class="page-container">

    <!-- Hero Section -->
    <div class="hero-section">
        <div class="content-container hero-content">
            <h1 style="color: white;" class="hero-title font-oswald">EL REY METRICS</h1>
            <p class="hero-subtitle font-inter">Descomplique as suas métricas. Centralize os seus resultados de Instagram e Facebook Ads numa única plataforma, exclusiva para clientes El Rey Labs.</p>
            <a href="#cta" class="cta-button">Solicitar Acesso</a>
        </div>
    </div>

    <!-- Main Content -->
    <div class="main-content">
        <div class="content-container">
            
            <!-- Features Section -->
            <div class="content-section text-center">
                <h2 class="section-title font-oswald">Tudo o que precisa para analisar a sua performance</h2>
                <p class="section-description">Uma ferramenta poderosa e intuitiva, desenhada para o seu sucesso.</p>
                <div class="features-grid">
                    <div class="feature-card">
                        <i class="icofont-dashboard-web feature-icon"></i>
                        <h3 class="font-oswald">Dashboard Unificado</h3>
                        <p>Visualize as métricas mais importantes do seu perfil de Instagram e das suas campanhas de anúncios num único lugar.</p>
                    </div>
                    <div class="feature-card">
                        <i class="icofont-chart-growth feature-icon"></i>
                        <h3 class="font-oswald">Análise de Performance</h3>
                        <p>Acompanhe o crescimento de seguidores, alcance, engajamento, cliques, CPR e ROAS de forma simplificada.</p>
                    </div>
                    <div class="feature-card">
                        <i class="icofont-file-alt feature-icon"></i>
                        <h3 class="font-oswald">Relatórios Simplificados</h3>
                        <p>Gere relatórios de fácil compreensão para avaliar o impacto das suas estratégias de marketing digital.</p>
                    </div>
                    <div class="feature-card">
                        <i class="icofont-lock feature-icon"></i>
                        <h3 class="font-oswald">Acesso Exclusivo e Seguro</h3>
                        <p>A plataforma garante que apenas os utilizadores autorizados sob contrato tenham acesso aos seus dados.</p>
                    </div>
                </div>
            </div>

            <!-- How it Works Section -->
            <div class="content-section">
                <h2 class="section-title font-oswald text-center">Como Funciona?</h2>
                <div class="process-steps">
                    <div class="step-card">
                        <div class="step-number">1</div>
                        <h3 class="font-oswald">Seja Nosso Cliente</h3>
                        <p>O acesso ao El Rey Metrics é um benefício exclusivo para clientes com um contrato de serviço ativo com a El Rey Labs.</p>
                    </div>
                    <div class="step-arrow">
                        <i class="icofont-arrow-right"></i>
                    </div>
                    <div class="step-card">
                        <div class="step-number">2</div>
                        <h3 class="font-oswald">Receba o seu Acesso</h3>
                        <p>A nossa equipa criará as suas credenciais e fornecerá todas as instruções para o primeiro acesso à plataforma.</p>
                    </div>
                     <div class="step-arrow">
                        <i class="icofont-arrow-right"></i>
                    </div>
                    <div class="step-card">
                        <div class="step-number">3</div>
                        <h3 class="font-oswald">Conecte as suas Contas</h3>
                        <p>Com segurança, conecte as suas contas do Instagram e Facebook Ads para que a magia aconteça.</p>
                    </div>
                </div>
            </div>

            <!-- CTA Section -->
            <div id="cta" class="content-section cta-section">
                <h2 class="font-oswald">Pronto para potenciar as suas análises?</h2>
                <p>O El Rey Metrics é um serviço de valor acrescentado, disponibilizado exclusivamente para os nossos clientes.</p>
                <p>Se tem interesse em otimizar a sua análise de dados e tornar-se nosso parceiro, entre em contacto com a nossa equipa comercial. Teremos todo o gosto em apresentar-lhe as nossas soluções.</p>
                <a href="mailto:comercial@elreylabs.com.br" class="cta-button-main">Entrar em Contacto com o Comercial</a>
            </div>

        </div>
    </div>
    
    <!-- Footer -->

</div>